__turbopack_context__.v({
  "icon": "FeatureLink-module__xEbWcW__icon",
  "inline": "FeatureLink-module__xEbWcW__inline",
  "label": "FeatureLink-module__xEbWcW__label",
  "link": "FeatureLink-module__xEbWcW__link",
});
